export default "/accountSdk/statics/icon-company.png"